import * as React from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import MobileStepper from '@mui/material/MobileStepper';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser'
import { useTheme } from '@mui/material/styles'

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const API = require("../../data/network/API");

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Stepper(props) {
  const authUser = useAuthUser()
  const {questionary, setComplete} = props
  const [activeStep, setActiveStep] = React.useState(0)
  const [selectedIndex, setSelectedIndex] = React.useState(null)
  const [questionaryAnswered, setQuestionaryAnswered] = React.useState(questionary)
  const [lock, setLock] = React.useState(false)
  const [multiple, setMultiple] = React.useState([])

  const theme = useTheme();

  const handleListItemClick = (event, index) => {
    var quest = questionary
    if(lock===false){
        if(quest.preguntas[activeStep].seleccion_multiple == true){
           
            setMultiple([...multiple, index])
            quest.preguntas[activeStep].opciones_seleccionadas = multiple
            setQuestionaryAnswered(quest)

        }else{
            setSelectedIndex(index);
            quest.preguntas[activeStep].opcion_seleccionada = index
            setLock(true)
            setQuestionaryAnswered(quest)
        }
    }
  }

  const handleSubmitFreeAnswer = async(event) => {
    event.preventDefault();
    if(lock === false){
      const data = new FormData(event.currentTarget);
      const respuesta = data.get('respuesta')
      var quest = questionary
      quest.preguntas[activeStep].respuesta_usuario = respuesta
      setLock(true)
      setQuestionaryAnswered(quest)
    }
  }

  async function postPoll(){

    console.log(authUser)
    const signin_data = localStorage.getItem("signin-data");
    const data = JSON.parse(signin_data);

    const requestBody= questionaryAnswered
    requestBody.id_usuario = data.usuario.firestore_id 

    console.log(requestBody)

    const response = await API.postPoll(requestBody)
    console.log(response)
    if(response.status == 200){

    }else{

    }
  }

  function handleNext() {
    if(activeStep == questionary.preguntas.length-1){
      setComplete(true)
      postPoll()
      return
    }
    setSelectedIndex(null)
    setLock(false)
    setActiveStep(activeStep + 1);
    setMultiple([])
  }

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    setSelectedIndex(null)
    setLock(false)
    setMultiple([])
  };

  function letterByIndex(index){
    const abc= ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "ñ", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]
    return abc[index]+")"
  }


  return (
    <Box sx={{ alignContent: "center" }}>
      <Stack spacing={5} sx={{ mb:4, minHeight:200 }}>
        <Typography variant="h4" sx={{fontWeight:"bolder", textAlign:'center'}} > {questionary.preguntas[activeStep].pregunta}</Typography>
      </Stack>
      <>
      {questionary.preguntas[activeStep].opciones && questionary.preguntas[activeStep].opciones.length > 0?
        <>
          <List >
            {questionary.preguntas[activeStep].opciones?.map((opcion) => (
              <ListItemButton
                key={opcion.id}
                sx={{ 
                  mb: 2, 
                  borderRadius: 16,
                  color: selectedIndex == opcion.id ? "white !important": "black !important",
                  backgroundColor: "#fff !important",
                  "&.Mui-selected": {
                    backgroundColor: selectedIndex != null ? selectedIndex == opcion.id ? "#008000 !important": "#FF0000 !important":"#008000 !important" ,
                    color: "white",
                    
                    "@keyframes slideInFromRight": {
                      "0%" :{ transform: "rotate(0deg)" },
                      "25%" :{ transform: "rotate(5deg)" },
                      "50%" :{ transform: "rotate(0eg)" },
                      "75%" :{ transform: "rotate(-5deg)" },
                      "100%": { transform: "rotate(0deg)" },
                    },
                   animation: "slideInFromRight 0.6s ease-out forwards",
                  
                  },
                  "&:hover": {
                      backgroundColor: "#FFF"
                  }
                }} 
                selected={selectedIndex == opcion.id ? true : multiple.includes(opcion.id)}
                onClick={(event) => handleListItemClick(event, opcion.id)}
              >
                <ListItemText key={opcion.id} primary={<Typography variant="body" sx={{fontWeight:'bolder'}}>{letterByIndex(opcion.id)} {opcion.opcion}</Typography>} />
              </ListItemButton>
            ))}
          </List>
        </>
          :
          <Box component="form" noValidate onSubmit={handleSubmitFreeAnswer} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="respuesta"
              name="respuesta"
              autoComplete="text"
              variant="outlined"
              autoFocus
              color='secondary'
              label = "Ingresa tu respuesta"
              helperText = "Ingresa tu respuesta"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color='secondary'
              sx={{ mt: 3, mb: 2 }}
            >
              enviar
            </Button>
          </Box> 
      }
      </>
     
        <MobileStepper
          variant="text"
          sx={{ bgcolor: 'transparent', '& .MuiMobileStepper-dot': {
            backgroundColor: 'darkgray',
          },
          '& .MuiMobileStepper-dotActive': {
            backgroundColor: "white",
          },}}
        
          steps={questionary.preguntas.length}
          position="static"
          activeStep={activeStep}

          nextButton={
            <Button
              size="small"
              variant='filled'
              onClick={handleNext}
              disabled={!lock && multiple.length == []}
            >
              Siguiente
              {theme.direction === 'rtl' ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          }
          backButton={
            <Button  variant='filled' size="small" onClick={handleBack} disabled={activeStep === 0}>
              {theme.direction === 'rtl' ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              Regresar
            </Button>
          }
        />
  
    </Box>
  )
}

export default function PollQuestions() {
  const {state} = useLocation();
  const navigate = useNavigate();
  const [questionary, setQuestionary] = React.useState(state);
  const [open, setOpen] = React.useState(false);
  const [complete, setComplete] = React.useState(false);

  const handleClickOpen = () => {
      setOpen(true);
  }
  
  const handleClose = () => {
      setOpen(false);
      navigate('/main/home');
  }
  
  return (
      <Box sx={{ 
            flexGrow: 1, 
            px: 2, 
            flexGrow: 1 ,
            backgroundImage: `radial-gradient(circle at top left, rgba(60, 60, 60, 0.39) 0%, rgba(10, 10, 10, 0.86) 100%), url(${questionary.imagen_url}) !important`,
            backgroundRepeat: `no-repeat`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: "93vh",
            width: "100%",
        }}>    
           <Stack spacing={1} sx={{pt:10,mb:2}}> 
                {complete != true ?
                <Stepper questionary = {questionary} setComplete={setComplete}></Stepper>
                :<>
                <Typography variant="h2" gutterBottom sx = {{textAlign:'center'}}>
                    ¡Gracias por participar!
                </Typography>
                <Button disabled={!complete} size="large" fullWidth variant='contained' color='secondary' onClick={handleClickOpen}>
                    Continuar
                </Button>
                </>
                }
            </Stack>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"¡Tus respuestas han sido enviadas!"}</DialogTitle>
            </Dialog>
      </Box>
  )
}